// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.autocomplete {
  width: 100%;
}

/* centra lo spinner */
ion-spinner {
  width: inherit;
}

ul, ion-spinner {
  position: absolute;
  width: inherit;
  margin-top: 0px;
  background: #FFF;
  list-style-type: none;
  padding: 0px;
  left: 16px;
  z-index: 999;
  box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 1px 5px 0 rgba(0, 0, 0, 0.12);
}

li {
  padding: 15px;
  border-bottom: 1px solid #c1c1c1;
}

li:last-child {
  border: none;
}

li:hover {
  cursor: pointer;
  background: #f1f1f1;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/auto-complete/auto-complete.component.scss"],"names":[],"mappings":"AAAA;EACI,WAAA;AACJ;;AAEA,sBAAA;AACA;EACI,cAAA;AACJ;;AAEA;EACI,kBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,YAAA;EACA,UAAA;EACA,YAAA;EACA,+GAAA;AACJ;;AAEA;EACI,aAAA;EACA,gCAAA;AACJ;;AAEA;EACI,YAAA;AACJ;;AAEA;EACI,eAAA;EACA,mBAAA;AACJ","sourcesContent":[".autocomplete {\n    width: 100%;\n}\n\n/* centra lo spinner */\nion-spinner {\n    width: inherit;  \n}\n\nul, ion-spinner {\n    position: absolute;\n    width: inherit;\n    margin-top: 0px;\n    background: #FFF;\n    list-style-type: none;\n    padding:0px;\n    left: 16px;\n    z-index: 999;\n    box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 1px 5px 0 rgba(0, 0, 0, 0.12);\n}\n\nli {\n    padding: 15px;\n    border-bottom: 1px solid #c1c1c1;\n}\n\nli:last-child {\n    border: none;\n}\n\nli:hover {\n    cursor: pointer;\n    background: #f1f1f1\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
